import { render } from "./AlphaOnlyInput.vue?vue&type=template&id=28ba4dfd"
import script from "./AlphaOnlyInput.vue?vue&type=script&lang=js"
export * from "./AlphaOnlyInput.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__